module.exports = __webpack_public_path__ + "bb474f16c9f76f522d656d66aa4a220e.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto-v15-latin-500.woff2
// module id = 1090
// module chunks = 0